import React, { useState, useEffect, useRef } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ClipLoader } from 'react-spinners';
import { toast } from "react-toastify";
import * as XLSX from "xlsx-js-style";

const TenantOccupancyReport = () => {
    const apiService = new LeaseApiService();
    const gridRef = useRef();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(50);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [formData, setFormData] = useState({
        property: { label: "All", value: "All" },
        asOn: "",
    })
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    useEffect(() => {
        fetchDropdownData();
        setFormData((prev) => ({
            ...prev,
            asOn: formatDate(new Date()),
        }));
    }, []);
    const handleDateChange = (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;
        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        setFormData((prev) => ({ ...prev, [name]: updatedValue }));
    }

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties,');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 50);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            params.append("AsOn", formData?.asOn || formatDate(new Date()));
            const res = await apiService.getApiParamater("REPORT_TENANT_OCCUPANCY", `?${params.toString()}`);
            if (res?.data?.result) {
                setRowData(res?.data?.result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoader(false)
            setLoading(false);
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            params.append("AsOn", formData?.asOn || formatDate(new Date()));
            const res = await apiService.getApiParamater("REPORT_TENANT_OCCUPANCY", `?${params.toString()}`);
            if (res?.data?.result) {
                setExportData(res?.data?.result || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoading(false);
        }
    }
    const columnDefs = [
        { headerName: "Property No", field: "property_No", filter: true, floatingFilter: true, suppressMovable: true, width: 130, pinned: "left" },
        { headerName: "Property Name", field: "property_Name", filter: true, floatingFilter: true, suppressMovable: true, width: 200, pinned: "left" },
        { headerName: "Total Leasable Area", field: "total_Leasable_Area", filter: true, floatingFilter: true, suppressMovable: true, width: 160 },
        { headerName: "Total Leased Area", field: "total_Leased_Area", filter: true, floatingFilter: true, suppressMovable: true, width: 160 },
        { headerName: "Total Blocked Area", field: "total_Blocked_Area", filter: true, floatingFilter: true, suppressMovable: true, width: 160 },
        { headerName: "Total Available Area", field: "total_Avalible_Area", filter: true, floatingFilter: true, suppressMovable: true, width: 160 },
        { headerName: "Leased % Area", field: "leased_Percentage_Area", filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: "Vacant % Area", field: "vacant_Percentage_Area", filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: "Total Leasable Units", field: "total_leaseable_units", filter: true, floatingFilter: true, suppressMovable: true, width: 160 },
        { headerName: "Leased Units", field: "leased_units", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: "Blocked Units", field: "blocked_units", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: "Vacant Units", field: "vacant_units", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: "Leased %", field: "leased_Percetnage", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: "Vacant %", field: "vacant_Percetnage", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    ]
    const handleClearFilters = () => {
        setRowData([])
        setFormData({
            property: { label: "All", value: "All" },
            asOn: formatDate(new Date()),
        });
    }
    const handleDropDownChange = ({ name, value }) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return "";
        return value;
    };
    const exportColumns = [
        { header: "Property No", dataKey: "property_No" },
        { header: "Property Name", dataKey: "property_Name" },
        { header: "Total Leasable Area", dataKey: "total_Leasable_Area" },
        { header: "Total Leased Area", dataKey: "total_Leased_Area" },
        { header: "Total Blocked Area", dataKey: "total_Blocked_Area" },
        { header: "Total Available Area", dataKey: "total_Avalible_Area" },
        { header: "Leased % Area", dataKey: "leased_Percentage_Area" },
        { header: "Vacant % Area", dataKey: "vacant_Percentage_Area" },
        { header: "Total Leasable Units", dataKey: "total_leaseable_units" },
        { header: "Leased Units", dataKey: "leased_units" },
        { header: "Blocked Units", dataKey: "blocked_units" },
        { header: "Vacant Units", dataKey: "vacant_units" },
        { header: "Leased %", dataKey: "leased_Percetnage" },
        { header: "Vacant %", dataKey: "vacant_Percetnage" },
    ];
    const fetchExportData = async () => {
        const params = new URLSearchParams();
        params.append("PageNo", 1);
        params.append("PageSize", pagination?.totalRecords || 100000);
        params.append("PropertyNo", formData?.property?.value?.value || "All");
        params.append("AsOn", formData?.asOn || formatDate(new Date()));
        const res = await apiService.getApiParamater("REPORT_TENANT_OCCUPANCY", `?${params.toString()}`);
        return res?.data?.result || [];
    };
    const exportPDF = async () => {
        setExportLoading(true);
        const data = await fetchExportData();
        setExportLoading(false);
        if (!data?.length) {
            toast.warning("No data to export");
            return;
        }
        setExportData(data);

        const doc = new jsPDF("landscape", "pt", "A4");

        doc.setFillColor(110, 81, 153);
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Occupancy Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Generated on: ${moment().format("DD-MMM-YYYY")}`,
            doc.internal.pageSize.width - 160,
            32
        );

        doc.setTextColor(0);

        doc.autoTable({
            startY: 60,
            head: [exportColumns.map(col => col.header)],
            body: data.map(row =>
                exportColumns.map(col => normalizeValue(row[col.dataKey]))
            ),
            styles: {
                fontSize: 8,
                cellPadding: 5,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save("Occupancy Report.pdf");
    };
    const exportExcel = async () => {
        setExportLoading(true);
        const data = await fetchExportData();
        setExportLoading(false);
        if (!data?.length) {
            toast.warning("No data to export");
            return;
        }
        setExportData(data);

        const title = "TENANT OCCUPANCY REPORT";

        // Reuse the grid's own column definitions (header + formatter) so the
        // export can never drift out of sync with what the grid shows.
        const columns = columnDefs.map(col => ({
            header: col.headerName,
            field: col.field,
            valueFormatter: col.valueFormatter,
        }));

        const dataRows = data.map(item =>
            columns.map(col =>
                col.valueFormatter
                    ? col.valueFormatter({ value: item[col.field], data: item })
                    : normalizeValue(item[col.field])
            )
        );

        const worksheet = XLSX.utils.aoa_to_sheet([
            [title],
            columns.map(c => c.header),
            ...dataRows,
        ]);

        // Merge Title
        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: columns.length - 1 } },
        ];

        // Auto column width
        worksheet["!cols"] = columns.map((col, i) => {
            const maxLength = Math.max(
                col.header.length,
                ...dataRows.map(r => String(r[i] ?? "").length)
            );
            return { wch: maxLength + 4 };
        });

        // Freeze header
        worksheet["!freeze"] = { ySplit: 2 };

        // Border style with color
        const borderStyle = {
            top: { style: "thin", color: { rgb: "FF000000" } },
            bottom: { style: "thin", color: { rgb: "FF000000" } },
            left: { style: "thin", color: { rgb: "FF000000" } },
            right: { style: "thin", color: { rgb: "FF000000" } },
        };

        // Title style
        const titleCell = worksheet["A1"];
        if (titleCell) {
            titleCell.s = {
                font: { bold: true, sz: 16, color: { rgb: "FF333333" } },
                alignment: { horizontal: "left", vertical: "center" },
                border: borderStyle,
            };
        }

        // Header style
        columns.forEach((_, c) => {
            const cell = worksheet[XLSX.utils.encode_cell({ r: 1, c })];
            if (!cell) return;

            cell.s = {
                font: { bold: true, sz: 11, color: { rgb: "FFFFFFFF" } },
                fill: { fgColor: { rgb: "FF6E5199" } },
                alignment: { horizontal: "center", vertical: "center" },
                border: borderStyle,
            };
        });

        // Data cells
        dataRows.forEach((row, r) => {
            columns.forEach((col, c) => {
                const cell = worksheet[XLSX.utils.encode_cell({ r: r + 2, c })];
                if (!cell) return;

                cell.s = {
                    font: { sz: 10, color: { rgb: "FF000000" } },
                    alignment: { vertical: "center", horizontal: "left" },
                    border: borderStyle,
                };
            });
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Occupancy Report");
        XLSX.writeFile(workbook, "Tenant_Occupancy_Report.xlsx");
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="d-flex flex-wrap justify-content-between align-items-end" style={{ maxWidth: '1200px', margin: 'auto', gap: '20px' }}>
                            <div className="d-flex" style={{ minWidth: '340px' }}>
                                <label htmlFor="validationCustom18" className="form-label">Property </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom19" className="form-label">As On</label>
                                <DatePicker
                                    selected={formData.asOn}
                                    onChange={(date) => handleDateChange({ name: 'asOn', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div
                                        onClick={() => getItems()}
                                        className="mainbtnGry flex-end gap-2 w-50"
                                    >
                                        <FaFileCircleExclamation
                                            color="#fff"
                                            className="center mt-2 mx-2"
                                        />
                                        <div className="center">Search</div>
                                    </div>
                                }
                                <div
                                    onClick={() => handleClearFilters()}
                                    className="mainbtnRed flex-end gap-2 w-50"
                                >
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-content-between">
                            <h5 className="col mainInvHead">Tenant Occupancy Report</h5>
                            <button className="btn btn-primary" onClick={exportPDF} disabled={exportLoading}>
                                {exportLoading ? <ClipLoader color="#ffffff" size={16} /> : "Export as PDF"}
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel} disabled={exportLoading}>
                                {exportLoading ? <ClipLoader color="#ffffff" size={16} /> : "Export as Excel"}
                            </button>
                        </div>

                        <div className="gridshad mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    ref={gridRef}
                                    getRowStyle={(params) => (params.node.rowIndex % 2 === 0 ? { background: "#F0EDF5" } : { background: "#fff" })}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default TenantOccupancyReport;
